"use client";

import { PAGE_LIMIT } from "@/lib/constant";
import { IconPaginationArrow } from "@repo/assets/images";
import { createQueryString } from "@repo/lib/utils";
import { Button } from "@repo/ui";
import cx from "classnames";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import NProgress from "nprogress";
import { useCallback } from "react";
const Pagination = props => {
  const {
    pageNumber,
    totalCount
  } = props; // pageNumber is 1-based now

  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  // Adjust the pageNumber for internal zero-based calculations
  const adjustedPageNumber = pageNumber - 1;

  // Get total pages count
  const totalPages = Math.ceil(totalCount / PAGE_LIMIT);
  const handleNextPage = useCallback(() => {
    NProgress.start();
    const updatedQueryString = createQueryString({
      page: pageNumber + 1
    }, searchParams);
    router.push(`${pathname}?${updatedQueryString}`);
  }, [router, pathname, pageNumber, searchParams]);
  const handlePrevPage = useCallback(() => {
    NProgress.start();
    const updatedQueryString = createQueryString({
      page: pageNumber > 1 ? pageNumber - 1 : 1
    }, searchParams);
    router.push(`${pathname}?${updatedQueryString}`);
  }, [router, pathname, pageNumber, searchParams]);
  const handlePageChange = useCallback(page => {
    NProgress.start();
    const updatedQueryString = createQueryString({
      page: page + 1
    }, searchParams);
    router.push(`${pathname}?${updatedQueryString}`);
  }, [router, pathname, searchParams]);
  const handleFirstPage = useCallback(() => {
    NProgress.start();
    const updatedQueryString = createQueryString({
      page: 1
    }, searchParams);
    router.push(`${pathname}?${updatedQueryString}`);
  }, [router, pathname, searchParams]);
  const pageNumbers = [];

  // Determine the range of pages to show
  const startPage = Math.max(0, adjustedPageNumber - 2);
  const endPage = Math.min(totalPages - 1, adjustedPageNumber + 2);
  for (let i = startPage; i <= endPage; i++) {
    pageNumbers.push(i);
  }

  // Do not show pagination if items are less than page limit
  if (totalCount < PAGE_LIMIT) return;
  const commonButtonStyle = "w-[36px] h-[36px] md:w-[40px] md:h-[40px] border rounded-pagination-item border-pagination-itemBorder flex items-center justify-center bg-pagination-itemBg text-sm";
  return <div className="md:bg-pagination-bg flex justify-center space-x-2 py-3 md:space-x-2 rtl:space-x-reverse" data-sentry-component="Pagination" data-sentry-source-file="Pagination.jsx">
      <Button onClick={handlePrevPage} size="sm" disabled={pageNumber <= 1} className={cx(`rtl:rotate-180 ${commonButtonStyle}`)} aria-label="Previous" data-sentry-element="Button" data-sentry-source-file="Pagination.jsx">
        <IconPaginationArrow className={cx("mx-auto rotate-180 fill-current", {
        "text-pagination-icon": pageNumber <= 1,
        "text-pagination-icon": pageNumber >= 1
      })} data-sentry-element="IconPaginationArrow" data-sentry-source-file="Pagination.jsx" />
      </Button>

      {startPage > 0 && <>
          <Button onClick={handleFirstPage} size="sm" className={`text-black ${commonButtonStyle}`}>
            1
          </Button>
          <span className={`${commonButtonStyle} text-pagination-dots`}>
            ...
          </span>
        </>}

      {pageNumbers.map(page => <Button key={page} onClick={() => handlePageChange(page)} size="sm" className={cx(`${commonButtonStyle} text-pagination-text`, {
      "border-pagination-itemBorder !bg-pagination-activeBg text-pagination-activeText disabled:text-pagination-activeText border": page === adjustedPageNumber
    })} disabled={page === adjustedPageNumber}>
          {page + 1}
        </Button>)}
      {endPage < totalPages - 1 && <span className={`text-pagination-dots ${commonButtonStyle}`}>...</span>}
      {endPage < totalPages - 1 && <Button onClick={() => handlePageChange(totalPages - 1)} size="sm" className={`text-pagination-text ${commonButtonStyle}`}>
          {totalPages}
        </Button>}
      <Button onClick={handleNextPage} size="sm" disabled={adjustedPageNumber >= totalPages - 1} className={cx(`${commonButtonStyle} `, {
      "border-pagination-itemBorder border": adjustedPageNumber >= totalPages - 1
    })} aria-label="Next" data-sentry-element="Button" data-sentry-source-file="Pagination.jsx">
        <IconPaginationArrow className={cx("mx-auto fill-current rtl:rotate-180", {
        "text-pagination-icon": adjustedPageNumber >= totalPages - 1,
        "text-pagination-icon": adjustedPageNumber <= totalPages - 1
      })} data-sentry-element="IconPaginationArrow" data-sentry-source-file="Pagination.jsx" />
      </Button>
    </div>;
};
export default Pagination;